import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

export type Body = {
  name?: string
  password?: string
  confirmPassword?: string
  currentPassword?: string
}

export const updateUser = async (body: Body, id: string) => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  if (body.name) {
    const response = await fetch(`${BASE_URL_API}/users/${id}`, {
      method: 'PUT',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',

        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    })

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Sessão expirada')
      }
      throw new Error('Erro ao atualizar usuário.')
    }
  }

  if (body.password) {
    const dto = {
      current_password: body.currentPassword,
      new_password: body.password,
    }

    const response = await fetch(`${BASE_URL_API}/users/${id}/password`, {
      method: 'PUT',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(dto),
    })

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Sessão expirada')
      }
      const { detail } = (await response.json()) as { detail: string }

      if (detail === 'Incorrect username or password.') {
        throw new Error('Senha atual incorreta.')
      }

      if (
        detail ==
        "1 validation error detected: Value at 'previousPassword' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$"
      ) {
        throw new Error('Senha atual incorreta.')
      }

      throw new Error(detail ?? 'Erro ao atualizar usuário.')
    }
  }
}
